module.exports = __webpack_public_path__ + "img/1454144021.c8581b41.jpg";